import React from 'react'
import { withRouter } from "react-router";
import { Link } from "react-router-dom";

import ls from "local-storage";
import * as CONFIG from './_config';



class Floral extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            coupanlist: [],
            department: [],
            dept: null,
            show: false,
            productdata: [],
            departmentinfo: null,
            dept1: [],

        }
    }

    componentDidMount() {
        ls.set('redirectTo', window.location.href);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            ls.set('redirectTo', window.location.href);
        }
    }

    render() {
        let dept1 = this.state.dept;

        return (

            <div>
                <div className="main-container default-page">

                    <div className='dsd'>

                        <div className="pt-5">
                            {CONFIG.DATA.THEME === 2 ?
                                <section id="apus-breadscrumb" className="breadcrumb-page apus-breadscrumb" style={{ backgroundColor: '#f3ffd9' }}>
                                    <div className="container">
                                        <div className="wrapper-breads">
                                            <div className="wrapper-breads-inner">
                                                <div className="breadscrumb-inner">
                                                    <h2 className="bread-title">Floral</h2>
                                                    <ol className="breadcrumb">
                                                        <li><a href="/">Home</a></li>
                                                        <li><span className="active">{`Floral`}</span></li>
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                :
                                <div className="title-breadcrumb">
                                    <div className="container">
                                        <header className="entry-header">
                                            {/* <h1 className="entry-title">{this.state.departmentinfo.departmentname}</h1> */}
                                        </header>
                                        <div className="breadcrumbs d-none d-md-block">
                                            <a href="/">Home</a>
                                            <span className="separator">/</span>
                                            {`Floral`}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className='col-md-11' style={{ margin: '0 0 12px 39px' }}>

                            <h1 style={{ float: 'left' }}>Floral </h1> <br /><br />

                            <p style={{ fontSize: '14px', textAlign: 'justify', float: 'left' }}>For the best and freshest flowers in Alexandria, Elden's downtwon Floral has exactly what you are looking for!
                                Check out our wide selection of flowers arrangments to make youe next occasion memeorable.</p>
                        </div>

                        <div className='floral-content container-fluid mt-5'>

                            <br /><br />

                            <div className='row'>
                                <div className='col-md-4 img1'>
                                    <a href="https://www.alexandriadowntownfloral.com/" target="_blank" rel='noopener noreferrer'>
                                        <img alt="Chester Chiken" loading="lazy"
                                            style={{ width: 'auto', maxWidth: 'none', padding: '12px', height: '330px' }}
                                            src={'/assets/images/users/Eldens.jpg'} /> </a></div>
                                <div className='col-md-4 img1'>
                                    <a href="https://www.eldensdowntownfloral.com/" target="_blank" rel='noopener noreferrer'>
                                    <img alt="Chester Chiken" loading="lazy" style={{ width: 'auto', maxWidth: 'none', padding: '12px', height: '330px' }} src={'/assets/images/users/teleflora.png'} />
                                        </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Floral);